import { NextPageContext } from "next";

export function withServerSideTestingProps<
  P extends { [key: string]: any; props?: { [key: string]: any } }
>(handler?: (ctx: NextPageContext) => Promise<P>) {
  return async (ctx: NextPageContext): Promise<P> => {
    const { getServerSideTestingProps } = await import("src/utility/statsig");
    const [testingProps, result] = await Promise.all([
      getServerSideTestingProps(ctx),
      handler ? handler(ctx) : { props: {} },
    ]);

    return {
      ...(result as any),
      props: {
        ...("props" in result && result.props ? result.props : {}),
        initialData: {
          ...("props" in result && result.props && "initialData" in result.props
            ? result.props.initialData
            : {}),
          ...testingProps,
        },
      },
    };
  };
}
